import React, { useState, useEffect, useContext } from 'react'
import { BottomAppCallout, Box, PageContainerMain } from '../../../Components/Layout'
import { useAuthContext, QuestionContext } from '../../../Context'
import { Question } from '../../../Api'
import { QuestionElem } from '../../../Components/Questions/Question'
import { useQuestionUrlParams } from '../../../Context/utils'
import { QuestionCon, QuestionSection } from '../styles'
import { AdUnit } from '../../../Components/Ads/AdUnit'
import { HelmetProvider } from 'react-helmet-async'
import { SEOTags } from '../../../Components/SEO/SEOTags'
import { Loading } from '../../Loading'

const SingleQuestion: React.FC = () => {
  const qId = useQuestionUrlParams()
  const { getQuestionSet } = useContext(QuestionContext)!
  const { userId, authLoading } = useAuthContext()
  const [question, setQuestion] = useState<Question | null>(null)
  const [loading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    if (!qId?.questionId || authLoading) return
    getQuestion(qId.questionId)
  }, [userId, authLoading])

  const getQuestion = async (questionId: string) => {
    const params = {
      questionId,
      qType: 'single',
    }
    const q = await getQuestionSet(params)
    if (q.length === 1) {
      if (q[0].startTime && q[0].startTime > Date.now() / 1000) {
        // if question is not live yet
        setLoading(false)
        return
      }
      setQuestion(q[0]) // all questions are returned in array
    }
    setLoading(false)
  }

  return (
    <HelmetProvider>
      <SEOTags
        title="Questions"
        description="Answer trivia, polls, and vote on PLL topics."
        keywords="voting, polls"
      />
      <PageContainerMain>
        <AdUnit bannerType="bannerMain" aria-label="Single question page ad" />
        <Box noMargin>
          <QuestionSection>
            {loading && <Loading />}
            {!loading && question && (
              <QuestionCon>
                <QuestionElem question={question} uiTheme="light" />
              </QuestionCon>
            )}
          </QuestionSection>
        </Box>
        {question && (
          <BottomAppCallout
            appLink={question.shareLink}
            location="Group_Questions_Page"
            text="This experience is better in the PLL App!"
          />
        )}
      </PageContainerMain>
    </HelmetProvider>
  )
}

export default SingleQuestion
